function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var supportsLocalStorage = (function () {
  if (typeof window === 'undefined' || !('localStorage' in window)) {
    return false;
  }

  var TEST_KEY = 'test-key';
  var TEST_VALUE = 'test-value';

  try {
    localStorage.setItem(TEST_KEY, TEST_VALUE);
    var value = localStorage.getItem(TEST_KEY);
    localStorage.removeItem(TEST_KEY);
    return value === TEST_VALUE;
  } catch (error) {
    return false;
  }
})();

var supportsRequestAnimationFrame = typeof window !== 'undefined' && 'requestAnimationFrame' in window;

var DEFAULT_LOCAL_STORAGE_KEY_NAME = 'color-scheme';
var COLOR_SCHEME_LIGHT = 'light';
var COLOR_SCHEME_DARK = 'dark';
var COLOR_SCHEMES = [COLOR_SCHEME_LIGHT, COLOR_SCHEME_DARK];
var colorScheme = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$localStorageKeyN = _ref.localStorageKeyName,
      localStorageKeyName = _ref$localStorageKeyN === void 0 ? DEFAULT_LOCAL_STORAGE_KEY_NAME : _ref$localStorageKeyN;

  if (!supportsLocalStorage) {
    return;
  }

  var userColorScheme = localStorage.getItem(localStorageKeyName);

  if (userColorScheme === null) {
    return;
  }

  if (!COLOR_SCHEMES.includes(userColorScheme)) {
    localStorage.removeItem(localStorageKeyName);
    return;
  } // TODO: add the ability to customise this class/attr name


  document.documentElement.classList.add("t-".concat(userColorScheme));
});

var script = {
  props: {
    localStorageKeyName: {
      type: String,
      default: DEFAULT_LOCAL_STORAGE_KEY_NAME
    },
    defaultColorScheme: {
      type: String,
      default: COLOR_SCHEME_LIGHT,
      validate: function validate(colorScheme) {
        return COLOR_SCHEMES.includes(colorScheme);
      }
    }
  },
  data: function data() {
    return {
      userColorScheme: supportsLocalStorage ? localStorage.getItem(this.localStorageKeyName) : null,
      systemColorScheme: this.getSystemColorScheme()
    };
  },
  computed: {
    label: function label() {
      return "Change color scheme to '".concat(this.colorScheme === COLOR_SCHEME_LIGHT ? COLOR_SCHEME_DARK : COLOR_SCHEME_LIGHT, "' mode");
    },
    colorScheme: function colorScheme() {
      return this.userColorScheme || this.systemColorScheme;
    }
  },
  watch: {
    colorScheme: function colorScheme(currentValue, previousValue) {
      if (supportsLocalStorage) {
        localStorage.setItem(this.localStorageKeyName, currentValue);
      }

      if (supportsRequestAnimationFrame) {
        requestAnimationFrame(function () {
          document.documentElement.classList.remove("t-".concat(previousValue));
          document.documentElement.classList.add("t-".concat(currentValue));
        });
        return;
      }

      document.documentElement.classList.remove("t-".concat(previousValue));
      document.documentElement.classList.add("t-".concat(currentValue));
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.userColorScheme !== null) {
      return;
    }

    this.mediaQueryLists = COLOR_SCHEMES.map(function (colorScheme) {
      return matchMedia("(prefers-color-scheme: ".concat(colorScheme));
    });
    this.mediaQueryLists.forEach(function (mediaQuery) {
      mediaQuery.addListener(_this.handleSystemColorSchemeChange);
    });
  },
  destroyed: function destroyed() {
    var _this2 = this;

    if (typeof this.mediaQueryLists === 'undefined') {
      return;
    }

    this.mediaQueryLists.forEach(function (mediaQuery) {
      mediaQuery.removeListener(_this2.handleSystemColorSchemeChange);
    });
  },
  methods: {
    handleSystemColorSchemeChange: function handleSystemColorSchemeChange(event) {
      var _event$target = event.target,
          matches = _event$target.matches,
          media = _event$target.media;

      if (!matches) {
        return;
      }

      var _media$match = media.match(/\(prefers-color-scheme: (\w+)\)/),
          _media$match2 = _slicedToArray(_media$match, 2),
          colorScheme = _media$match2[1];

      if (COLOR_SCHEMES.includes(colorScheme)) {
        this.systemColorScheme = colorScheme;
        return;
      }

      this.systemColorScheme = this.defaultColorScheme;
    },
    handleClick: function handleClick() {
      this.toggle();
    },
    toggle: function toggle() {
      if (this.colorScheme === COLOR_SCHEME_LIGHT) {
        this.userColorScheme = COLOR_SCHEME_DARK;
        return;
      }

      this.userColorScheme = COLOR_SCHEME_LIGHT;
    },
    getSystemColorScheme: function getSystemColorScheme() {
      if (typeof window === 'undefined') {
        return this.defaultColorScheme;
      }

      return COLOR_SCHEMES.reduce(function (previous, colorScheme) {
        var mediaQueryList = matchMedia("(prefers-color-scheme: ".concat(colorScheme, ")"));

        if (mediaQueryList.matches) {
          return colorScheme;
        }

        return previous;
      }, this.defaultColorScheme);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "color-scheme-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('span', {
    staticClass: "indicator",
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-a5e45fd2_0", {
    source: ".color-scheme-toggle[data-v-a5e45fd2]{width:48px;padding:4px;background-color:#c8c8cc;border-radius:20px;border:0;cursor:pointer}.color-scheme-toggle.focus-visible[data-v-a5e45fd2]{outline:2px solid gold;outline-offset:2px}.color-scheme-toggle[data-v-a5e45fd2]:focus-visible{outline:2px solid gold;outline-offset:2px}.color-scheme-toggle[data-v-a5e45fd2]:focus:not(.focus-visible){outline:0}.color-scheme-toggle[data-v-a5e45fd2]:focus:not(:focus-visible){outline:0}.color-scheme-toggle .indicator[data-v-a5e45fd2]{display:block;width:20px;height:20px;background-color:#0c0c10;border-radius:100%;transform:translateX(0);transition:transform .2s,background-color .2s;will-change:transform,background-color}@media (prefers-color-scheme:dark){.color-scheme-toggle .indicator[data-v-a5e45fd2]{background-color:#242428;transform:translateX(20px)}}.t-light .color-scheme-toggle .indicator[data-v-a5e45fd2]{background-color:#0c0c10;transform:translateX(0)}.t-dark .color-scheme-toggle .indicator[data-v-a5e45fd2]{background-color:#242428;transform:translateX(20px)}.color-scheme-toggle .label[data-v-a5e45fd2]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-a5e45fd2";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
export { colorScheme as addColorSchemeClassName };
